/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const UserInfoWithRoleParser = /* #__PURE__ */ parsers.object([
    ['roleId', codecNumber, 'role_id'],
    ['username', codecString],
    ['name', codecString],
    ['email', codecString],
]);
export class UserInfoWithRole extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UserInfoWithRoleParser.decode(input).map(res => new UserInfoWithRole(res));
    }
    static unsafeDecode(input) {
        return UserInfoWithRole.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UserInfoWithRoleParser.encode(data);
    }
    static schema() {
        return UserInfoWithRoleParser.schema();
    }
}
